// extracted by mini-css-extract-plugin
export default {"header":"editedPropertiesPanelNew_header__x27NG","container":"editedPropertiesPanelNew_container__phmrf"};